export const iconFontAwesomeHumanitarianSoap = (
	<i className="fa-solid fa-soap"></i>
);
